import { OrderReprocessDto } from './../../model/order-reprocess-dto';
import { FileExportService } from './../../services/file-export.service';
import { AfterViewInit, Component, OnInit, Input, ViewChild, Inject } from '@angular/core';
import { Purchaseorderdto } from 'src/app/model/purchageorderdto';
import { OrderDetailsdto } from 'src/app/model/orderDetailsdto';
import { DatePipe } from '@angular/common';
import { HttpclientService } from 'src/app/services/httpclient.service';
import { PurchaseOrderComponent } from '../purchase-order/purchase-order.component';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { OrderInterfaceLogFileDto } from 'src/app/model/order-interface-log-file-dto';
import { ResultDto } from 'src/app/model/result-dto';
declare var $: any;

@Component({
  selector: 'app-po-tableacr-table',
  templateUrl: './po-tableacr-table.component.html',
  styleUrls: ['./po-tableacr-table.component.css']
})
export class PoTableacrTableComponent implements OnInit, AfterViewInit {
  oneAtATime;
   orderDetailsdto: OrderDetailsdto;
  @Input() data : any;
  isCreateBolBtnVisible: boolean;

  isPurchaseOrder: boolean;
  orderInterfaceLogFileDto: OrderInterfaceLogFileDto;
  resultDto: ResultDto;
  str: any;
  purchaseOrderDtoVar : any[] = [];
  purchaseorders :Purchaseorderdto;
  showArrow: any[] = [];
  itemIndex=0;
  userRoleId;
  isDistributor:boolean;
  isAdmin:boolean;
  
  @ViewChild (PurchaseOrderComponent, {static: false}) poChild: PurchaseOrderComponent;
  pipe = new DatePipe('en-US');
  now = Date.now();

  constructor(public fileExportService: FileExportService,
             private httpclientService: HttpclientService,
              @Inject(PurchaseOrderComponent) public parentComp: PurchaseOrderComponent,
              public appSettingService: AppSettingService) {

                if ( sessionStorage.getItem('roleId') === '3' ){
                  this.parentComp.isPartner = true;
          console.log('true..'+this.parentComp.isPartner);
                } else{
                  this.parentComp.isPartner = false;
                }
                this.setSessionVariableForCreateBolMenue();                
                this.userRoleId = sessionStorage.getItem('roleId');     
                this.isDistributor = sessionStorage.getItem('roleId')!='6' ? false : true;      
                this.isAdmin = sessionStorage.getItem('roleId')=='1' ? true : false;     
   }

   ngAfterViewInit() {
    // Redefine `seconds()` to get from the `CountdownTimerComponent.seconds` ...
    // but wait a tick first to avoid one-time devMode
    // unidirectional-data-flow-violation error
    console.log("ngAfterViewInit in po-tableacr-table.component");
    // let polen = this.purchaseorders.length;
    // console.log("purchaseOrderNumber"+this.purchaseorders.purchaseOrderNumber);
    // console.log("billDocNumber"+this.purchaseorders.billDocNumber);
    this.purchaseOrderDtoVar = this.parentComp.purchaseorders;
    console.log('length:'+this.purchaseOrderDtoVar.length);
    // console.log('billdoc:'+this.purchaseOrderDtoVar[1].billDocNumber);
    // console.log("END of ngAfterViewInit in po-tableacr-table.component");
    
    // let arr1 = [];
            for(let i = 0 ; i < this.parentComp.purchaseorders.length; i++){
              let bdoc: any[] =[];
              let newBdoc: any = "";
              if(this.parentComp.purchaseorders[i].billDocNumber != null && this.parentComp.purchaseorders[i].billDocNumber != ""){
                console.log("this.parentComp.purchaseorders"+this.parentComp.purchaseorders[i].billDocNumber);
                console.log("this.parentComp.purchaseorders[i].billDocArray"+this.parentComp.purchaseorders[i].billDocArray);
                let str = this.parentComp.purchaseorders[i].billDocNumber;
                bdoc = str.split(',');
                // console.log("str"+this.str);
                // bdoc += '<a href="value">'+this.str.split(",")+'</a>';
                console.log("bdoc"+bdoc);
              }
              
              for(let arr of bdoc){
                newBdoc += "<a href='"+arr+"'>";
                newBdoc += arr;
                newBdoc += "</a>";
                
              }
              console.log("newBdoc"+newBdoc);
              this.parentComp.purchaseorders[i].billDocNumber ===newBdoc;
            }
  }

  msg: any;

  billDocClick(e, item){
    console.log("Events", e);
    console.log("item", item);
    // alert("You have clicked the billDocClick anchor-1 tag"+item);
    // this.httpclientService.getPDFForInvoice(item).subscribe( data => {
    //   this.msg = data;
    //   console.log("msg"+this.msg);
    // });

    var invoiceNo=item.trim();
    this.httpclientService.getPDFForInvoice(invoiceNo).subscribe((responseMessage) => {
      
      console.log("InvoiceNO :"+invoiceNo);
      console.log("responseMessage"+responseMessage);
      let file = new Blob([responseMessage], { type: 'application/pdf' });
      var sizeInBytes = file.size;
      console.log("file length :"+sizeInBytes);
      console.log("file"+file);
      if(sizeInBytes>0){
        var fileURL = URL.createObjectURL(file);
        console.log("fileURL"+fileURL);
        
      
        var mySimpleFormat = this.pipe.transform(this.now, 'yyyy-MM-dd');

        var filename = invoiceNo +"_" +mySimpleFormat;
        console.log("filename :"+filename);
        // This is to view the pdf in new tab and below code to get downloaded to local
        // window.open(fileURL);
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;

        // it forces the name of the downloaded file
        fileLink.download = filename;

        // triggers the click event
        fileLink.click(); 

      // fileURL.download = 'pdf_name';
      // const doc = new jsPDF(fileURL);
      // doc.save(item + '.pdf');
      //  alert("Downloaded PDF for Invoice : "+item+" Successfully.");
      }else{
        alert("Unable to download PDF for Invoice : "+item+" Please contact admin.");
      }
    })
    console.log("END billDocClick");
 }

   getPurchaseOrder(poNo, event: boolean) {
    // console.log('poDto'+this.poDto.billDocNumber);
    let orderDetailsdtoNew: OrderDetailsdto;
    this.orderDetailsdto = orderDetailsdtoNew;
    console.log('expend' + poNo.purchaseOrderID + '..' + event + '...' + this.parentComp.loading);

    if (poNo.purchaseOrderID === 0) {
      this.isPurchaseOrder = true;
    } else {
      this.isPurchaseOrder = false;
      if (event) {
    this.parentComp.loading = true;
    this.httpclientService.gePurchasetOrderDetails(poNo.purchaseOrderID).subscribe( data => {
      this.parentComp.loading = false;
      this.orderDetailsdto = data;
     let len = this.orderDetailsdto.orderInterfaceLogDtoList.length;
     console.log("length of records for Purchase Order Id: "+poNo.purchaseOrderID+" is :"+len);
      for(let i = 0 ; i< len; i++){
        console.log('this.orderDetailsdto.orderInterfaceLogDtoList[i].typeOfTransaction' + this.orderDetailsdto.orderInterfaceLogDtoList[i].typeOfTransaction);
      if(this.orderDetailsdto.orderInterfaceLogDtoList[i].typeOfTransaction=="Bill Of lading"){
        this.orderDetailsdto.orderInterfaceLogDtoList[i].typeOfTransaction="Bill of Lading";
      }
      if(this.orderDetailsdto.orderInterfaceLogDtoList[i].typeOfTransaction=="Updated BOL"){
        this.orderDetailsdto.orderInterfaceLogDtoList[i].typeOfTransaction="Updated BoL";
      }
      if(this.orderDetailsdto.orderInterfaceLogDtoList[i].typeOfTransaction=="Debit Invoice"){
        this.orderDetailsdto.orderInterfaceLogDtoList[i].typeOfTransaction=="Debit Invoice";
        console.log("FileStateCodeId :"+this.orderDetailsdto.orderInterfaceLogDtoList[i].fileStateCodeId);
      }
      if(this.orderDetailsdto.orderInterfaceLogDtoList[i].typeOfTransaction=="Credit Invoice"){
        this.orderDetailsdto.orderInterfaceLogDtoList[i].typeOfTransaction=="Credit Invoice";
        console.log("FileStateCodeId :"+this.orderDetailsdto.orderInterfaceLogDtoList[i].fileStateCodeId);
      }
    }
          }
      );
        }

      }
  }


  onSelect(selectedItem: any, values: any) {
    let checkStaus = true;
//     if (this.parentComp.selectedAllRow) {



// //     this.parentComp.purchaseorders.forEach(pdto => {
// // if(checkStaus){
// //       console.log('..row check...'+pdto.rowCheck);
// //       if (pdto.rowCheck) {
// //         checkStaus = true;
// //       } else if (!pdto.rowCheck) {
// //         checkStaus = false;
// //       }
// //     }
// //     });
//   }




    console.log('..' + checkStaus);
    console.log("Selected item Id: ", selectedItem.rowCheck + "..."+ values.currentTarget.checked); // You get the Id of the selected item here
    if (values.currentTarget.checked) {



      console.log('..' + checkStaus);

   //   this.parentComp.selectedAllRow = ''+checkStaus;

      this.fileExportService.selectedPoData.push(selectedItem);
    } else if (!values.currentTarget.checked) {

      this.fileExportService.selectedPoData = this.fileExportService.selectedPoData.filter(obj => obj !== selectedItem);

    }

    if(this.fileExportService.selectedPoData.length === this.parentComp.purchaseorders.length){
      this.parentComp.selectedAllRow = true;
    }else{
      this.parentComp.selectedAllRow = false;
    }


}
getPoOrderDetails(){

  console.log('expend');
}


fileExport() {
  console.log('calling');
}

  ngOnInit() {
    // $(document).ready(
    //   () => {
    //     $(".arrowHolder").on("click", function () {
    //       alert("POTABLE")
    //         $(this).find(".accDrpDwn1").toggleClass("accDrpDwnIcnOpen").toggleClass("accDrpDwnIcn");
    //     });
    //     }
    // )

}


getOrderFileDownload(docId , fileId, fileName, uniqueIdentificationText, fileArchivalId) {
  this.parentComp.loading = true;
  console.log("docId :"+docId);
  console.log("fileId :"+fileId);
  console.log("fileName :"+fileName);
  var newfileName = fileName.substring(fileName.lastIndexOf("\\")+1, fileName.indexOf("."));
  console.log("newfileName :"+newfileName);
  console.log("uniqueIdentificationText :"+uniqueIdentificationText);
  console.log("fileArchivalId :"+fileArchivalId);
  if(uniqueIdentificationText == ''){
    console.log("In Debit Credit download using filearchivalid :"+fileArchivalId);
    this.httpclientService.getOrderFileDownloadDebitCredit(docId, fileId, fileArchivalId).subscribe( data => {
      if (data != null) {
  
        this.orderInterfaceLogFileDto = data;
        const blob = new Blob([this.orderInterfaceLogFileDto.fileContent], { type: 'application/xml' });
      // window.location.href = '' + this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));
        const url= window.URL.createObjectURL(blob);
        var anchor = document.createElement("a");
        anchor.download = newfileName;
        anchor.href = url;
        anchor.click();
  
      // window.open(url);
        this.parentComp.loading = false;
      } else {
        this.parentComp.loading = false;
        this.parentComp.isXmlDataNotAvailable = true;
  
      }
      // window.location.href = this.orderInterfaceLogFileDto.fileContent;
      console.log('filename : '+this.orderInterfaceLogFileDto.fileName);
        console.log('this.orderInterfaceLogFileDto.fileContent..' + this.orderInterfaceLogFileDto.fileName);
              }, error => {
                this.parentComp.loading = false;
                alert('File is not found');
              },
          );   
  }else {
      console.log("In other file download using uniqueIdentificationText :"+uniqueIdentificationText);
      this.httpclientService.getOrderFileDownload(docId, fileId, uniqueIdentificationText).subscribe( data => {
    if (data != null) {

      this.orderInterfaceLogFileDto = data;
      const blob = new Blob([this.orderInterfaceLogFileDto.fileContent], { type: 'application/xml' });
    // window.location.href = '' + this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));
      const url= window.URL.createObjectURL(blob);
      var anchor = document.createElement("a");
      anchor.download = fileName;
      anchor.href = url;
      anchor.click();

    // window.open(url);
      this.parentComp.loading = false;
    } else {
      this.parentComp.loading = false;
      this.parentComp.isXmlDataNotAvailable = true;

    }
    // window.location.href = this.orderInterfaceLogFileDto.fileContent;
      console.log('this.orderInterfaceLogFileDto.fileContent..' + this.orderInterfaceLogFileDto.fileName);
            }, error => {
              this.parentComp.loading = false;
              alert('File is not found');
            },
        );
  }
}

getOrderReprocess(poId, docId , fileId, fileName, uniqueIdentificationText, poType,poNumber, bolreprocess,supplierDocReferenceNumber, fileArchivalId) {
  if(confirm("Need to Reprocess")){
  console.log('fileName..' + fileName);
  console.log('docId..' + docId);
  var newFileName = fileName.substring(0, fileName.length - 4);
  console.log('newFileName..' + newFileName);
  this.parentComp.loading = true;
  if(fileName.includes("Debit") || fileName.includes("Credit")){
    newFileName=fileName;
  }
  let orderReprocessDto= new OrderReprocessDto(poId, docId , fileId, newFileName, uniqueIdentificationText,
    poType,poNumber,bolreprocess,supplierDocReferenceNumber, fileArchivalId);
  this.httpclientService.savleOrderReprocess(orderReprocessDto).subscribe( data => {
    this.resultDto = data;
    console.log('data..' + this.resultDto.resultMessage);
    this.parentComp.loading = false;
    console.log('resultDto.resultMessage'+this.resultDto.resultMessage);
    alert(''+this.resultDto.resultMessage);
  }
  );
} else{
  console.log('In Confirm Dialog cancel..');
  
}
}

setSessionVariableForCreateBolMenue()
  {    
    for(let i=0; i<this.appSettingService.menubarGlobelList.length; i++)
          {              
              for(let  j = 0; j < this.appSettingService.menubarGlobelList[i].moduleName.length; j++)
              {
                 if(this.appSettingService.menubarGlobelList[i].moduleName[j] == 'Create Bol')
                 {                  
                  this.isCreateBolBtnVisible = true;
                  break;                                   
                 }                
                 else
                 {
                  this.isCreateBolBtnVisible = false;
                 }              
              }
                         
              if(this.isCreateBolBtnVisible)
              {           
                break;
              }
          }

  }

}
